import { Pipe, PipeTransform } from "@angular/core";
import { LocaleService } from "../services/locale.service";

@Pipe({
  name: "calendarDate",
  standalone: true,
})
export class CalendarDatePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}
  transform(value: string) {
    if (
      this.localeService.locale == "it-IT" ||
      this.localeService.locale == "pt-BR"
    ) {
      return "dd/MM/yyyy";
    } else {
      return "MM/dd/yyyy";
    }
  }
}
